import { Component } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';

/**
 * Hosts nested register-interest routes (form + thanks) so URLs stay under /register-interest/*.
 */
@Component({
  selector: 'app-register-interest-shell',
  standalone: true,
  imports: [IonRouterOutlet],
  template: '<ion-router-outlet></ion-router-outlet>',
})
export class RegisterInterestShellComponent {}
